// extracted by mini-css-extract-plugin
module.exports = {"imagLayout":"Relocation_imagLayout__3uN4G","description":"Relocation_description__UvbCo","imagMap":"Relocation_imagMap__3CI7K"};